var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "container", staticClass: "scale-selector" }, [
    _c(
      "div",
      {
        ref: "track",
        staticClass: "scale-selector-track",
        on: {
          mousedown: function ($event) {
            $event.stopPropagation()
            return _vm.handleMD($event)
          },
          mousemove: function ($event) {
            $event.stopPropagation()
            return _vm.handleMM($event)
          },
          mouseup: function ($event) {
            $event.stopPropagation()
            return _vm.handleMU($event)
          },
        },
      },
      [_c("div", { ref: "gauge", staticClass: "scale-selector-gauge" })]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }